module.exports = __webpack_public_path__ + "img/trophy-awards-dark.f4504278.svg";